/**
 * Returns the prequalification field list, with outlet-specific overrides applied.
 * For outlets eligible for the TSB takeover section (see tsbTakeoverEligibleOutlets),
 * the 'existingSecurityEquipment' field is excluded; all other outlets get the full
 * list unchanged.
 */
import { isTsbTakeoverEligibleOutlet } from '../../../../utils/constant';

export const updatePrequalificationField = (salesRepOutlet, prequalificationField) => {
  if (isTsbTakeoverEligibleOutlet(salesRepOutlet)) {
    return prequalificationField.filter(field => field !== 'existingSecurityEquipment');
  }
  return prequalificationField;
};
